import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsRecentlyVisitedProductsCarousel } from './recently-visited-products-carousel.interface';

export const CMS_COMPONENT_RECENTLY_VISITED_PRODUCTS_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsRecentlyVisitedProductsCarousel.ID,
    name: 'Recently Visited Products Carousel',
    tags: ['page', 'product'],
    isLayout: true,
    fields: [
        <NICmsContentField.ITextField>{
            key: 'category_title',
            type: NICmsContentField.EFieldType.text,
            title: 'Category carousel title',
            default: 'Category carousel',
            required: true
        },
        <NICmsContentField.IRelationField>{
            key: 'category_id',
            type: NICmsContentField.EFieldType.relation,
            title: 'Category ID',
            options: {
                title: 'Category',
                type: 'category',
                qty: 1
            }
        },
        <NICmsContentField.ITextField>{
            key: 'recently_title',
            type: NICmsContentField.EFieldType.text,
            title: 'Recently viewed carousel title',
            default: 'Recently Visited Products',
            required: true
        },
        <NICmsContentField.IField>{
            key: 'limit',
            type: NICmsContentField.EFieldType.number,
            title: 'Items limit',
            default: 8,
            required: true
        },
        <NICmsContentField.IField>{
            key: 'min_qty_for_recently_viewed',
            type: NICmsContentField.EFieldType.number,
            title: 'Min qty of products for recently viewed carousel',
            default: 2,
            required: true
        }
    ]
};
